import React, { useEffect, useState } from "react";
import EnhancedTable from "../elementos/basicos/TablaEmpresaLista";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchEliminarNegocios, fetchDepartamentosData, fetchNegociosFiltersData } from '../../peticiones_API/PeticionesGestionPersonasNegocios';
import { fetchEliminarEmpresasColaboradoras, fetchEmpresasColaboradorasFiltersData } from '../../peticiones_API/PeticionesEmpresasColaboradoras';
import { fetchEliminarEmpresa, fetchEmpresasFiltersData } from "../../peticiones_API/PeticionesGestionPersonasEmpresas"; 

import { fetchPersonasData } from "../../peticiones_API/PeticionesGestionPersonasPersonas";
import { ConfirmacionEliminarOficina } from './../elementos/eventos/avisos/VentanaEmergente';
import Titulo from "./../elementos/basicos/Titulo";
import styled from 'styled-components';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Building2, Handshake, Building } from 'lucide-react';

const GestionPersonasEmpresas = () => {
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();

    let busqueda = params.get("busqueda") || null;
    let departamento = params.get("departamento");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(false);
    const [tabActual, setTabActual] = useState(0);

    const [departamentos, setDepartamentos] = useState([]);
    const [personas, setPersonas] = useState([]);

    // Estado para empresas de negocio
    const [selected, setSelected] = useState([]);
    const [recargar, setRecargar] = useState(false);
    const [eliminarSeleccion, setEliminarSeleccion] = useState({ atributo: 'visible', valor: null });
    const [data, setData] = useState({ meta: {}, rows: [] });

    // Estado para empresas colaboradoras
    const [selectedColab, setSelectedColab] = useState([]);
    const [recargarColab, setRecargarColab] = useState(false);
    const [eliminarSeleccionColab, setEliminarSeleccionColab] = useState({ atributo: 'visible', valor: null });
    const [dataColab, setDataColab] = useState({ meta: {}, rows: [] });

    // Estado para empresas 
    const [selectedEmpresa, setSelectedEmpresa] = useState([]);
    const [recargarEmpresa, setRecargarEmpresa] = useState(false);
    const [eliminarSeleccionEmpresa, setEliminarSeleccionEmpresa] = useState({ atributo: 'visible', valor: null });
    const [dataEmpresa, setDataEmpresa] = useState({ meta: {}, rows: [] });

    const construirParametrosURL = (pagina) => {
        let urlParams = `?pagina=${pagina}&registrosPorPag=${registrosPorPag}`;
        if (busqueda !== null && busqueda !== '' && busqueda !== undefined) urlParams += `&busqueda=${busqueda}`;
        if (departamento !== null) urlParams += `&departamento=${departamento}`;
        if (ordenarColumna !== null) urlParams += `&ordenarColumna=${ordenarColumna}`;
        if (orden !== null) urlParams += `&orden=${orden}`;
        return urlParams;
    };

    useEffect(() => {
        async function fetchPrincipal() {
            const personasResponse = await fetchPersonasData();
            setPersonas(personasResponse);
            const departamentosResponse = await fetchDepartamentosData();
            setDepartamentos(departamentosResponse);
        }
        fetchPrincipal();
    }, []);

    // Cargar Negocios
    useEffect(() => {
        if (tabActual !== 0) return;
        async function fechtPrincipal() {
            try {
                if (!paginaActual || !registrosPorPag) {
                    const empresasResponse = await fetchNegociosFiltersData(paginaActual, registrosPorPag);
                    const { data: empresasData, meta } = empresasResponse;
                    paginaActual = meta.current_page;
                    registrosPorPag = meta.per_page;
                    navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    setData({ meta, rows: empresasData });
                } else {
                    const urlParams = construirParametrosURL(paginaActual);
                    navigate(`${urlPadre}${urlParams}`);
                    const empresasResponse = await fetchNegociosFiltersData(paginaActual, registrosPorPag, departamento, busqueda, ordenarColumna, orden);
                    const { data: empresasData, meta } = empresasResponse;
                    if (empresasData.length === 0 && paginaActual > 1 && meta.total > 0) {
                        const urlParamsPage1 = construirParametrosURL(1);
                        navigate(`${urlPadre}${urlParamsPage1}`);
                        return;
                    }
                    setData({ meta, rows: empresasData });
                }
            } catch (error) {
                console.log("Ha habido un error:", error);
            } finally {
                setLoading(false);
            }
        }
        fechtPrincipal();
    }, [recargar, paginaActual, registrosPorPag, departamento, busqueda, ordenarColumna, orden, navigate, urlPadre, tabActual]);

    //Cargar empresas
    useEffect(() => {
        if (tabActual !== 1) return;
        async function fetchNegocio() {
            try {
                const page = paginaActual || 1;
                const limit = registrosPorPag || 10;
                const response = await fetchEmpresasFiltersData(page, limit, busqueda, ordenarColumna, orden); 
                if (response) {
                    const { data: negocioData, meta } = response;
                    setDataEmpresa({ meta, rows: negocioData });
                    console.log(response)
                }
            } catch (error) {
                console.log("Error cargando empresas de negocio:", error);
            }
        }
        fetchNegocio();
    }, [recargarEmpresa, paginaActual, registrosPorPag, busqueda, ordenarColumna, orden, tabActual]);
    
    // Cargar empresas colaboradoras
    useEffect(() => {
        if (tabActual !== 2) return;
        async function fetchColaboradoras() {
            try {
                const page = paginaActual || 1;
                const limit = registrosPorPag || 10;
                const response = await fetchEmpresasColaboradorasFiltersData(page, limit, busqueda, ordenarColumna, orden);
                if (response) {
                    const { data: colabData, meta } = response;
                    setDataColab({ meta, rows: colabData });
                }
            } catch (error) {
                console.log("Error cargando empresas colaboradoras:", error);
            }
        }
        fetchColaboradoras();
    }, [recargarColab, paginaActual, registrosPorPag, busqueda, ordenarColumna, orden, tabActual]);

    const confirmDialog = ConfirmacionEliminarOficina();

    const funcionEliminar = async () => {
        if (selected.length === 0) {
            eliminarSeleccion.valor = null;
            return;
        }
        const confirm = await confirmDialog.showAlert("eliminar", "empresas");
        if (confirm) {
            let empresasEliminar = [];
            if (eliminarSeleccion.valor === false && selected.length !== 0) {
                setEliminarSeleccion((prevState) => ({ ...prevState, valor: null }));
                empresasEliminar = selected;
                await fetchEliminarNegocios(empresasEliminar);
                setSelected([]);
            }
            setRecargar(!recargar);
        }
    };

    const funcionEliminarColab = async () => {
        if (selectedColab.length === 0) {
            eliminarSeleccionColab.valor = null;
            return;
        }
        const confirm = await confirmDialog.showAlert("eliminar", "empresas colaboradoras");
        if (confirm) {
            let empresasEliminar = [];
            if (eliminarSeleccionColab.valor === false && selectedColab.length !== 0) {
                setEliminarSeleccionColab((prevState) => ({ ...prevState, valor: null }));
                empresasEliminar = selectedColab;
                await fetchEliminarEmpresasColaboradoras(empresasEliminar);
                setSelectedColab([]);
            }
            setRecargarColab(!recargarColab);
        }
    };

    const funcionEliminarEmpresa = async () => {
        if (selectedEmpresa.length === 0) {
            eliminarSeleccionEmpresa.valor = null;
            return;
        }
        const confirm = await confirmDialog.showAlert("eliminar", "empresas de empresa");
        if (confirm) {
            let empresasEliminar = [];
            if(eliminarSeleccionEmpresa.valor === false && selectedEmpresa.length !== 0){
                setEliminarSeleccionEmpresa((prevState) => ({ ...prevState, valor: null }))
                empresasEliminar = selectedEmpresa;
                await fetchEliminarEmpresa(empresasEliminar);
                setSelectedEmpresa([]);
            }
            setRecargarEmpresa(!recargarEmpresa)
        }
    };

    if (eliminarSeleccion.valor !== null) {
        funcionEliminar();
    }
    if (eliminarSeleccionColab.valor !== null) {
        funcionEliminarColab();
    }

    if (eliminarSeleccionEmpresa.valor !== null) {
        funcionEliminarEmpresa()
    }

    const header = [
        { id: 'nombre', numeric: false, disablePadding: true, label: 'Nombre' },
        { id: 'departamentos', numeric: true, disablePadding: false, label: 'Departamentos' },
        { id: 'personas', numeric: true, disablePadding: false, label: 'Personas' },
        { id: 'modificar', numeric: true, disablePadding: false, label: '' }
    ];

    const headerEmpresas = [
        { id: 'razonSocial', numeric: false, disablePadding: true, label: 'Razón Social' },
        { id: 'cif', numeric: true, disablePadding: false, label: 'CIF' },
        { id: 'direccionSocial', numeric: true, disablePadding: false, label: 'Dirección social' },
        { id: 'cp', numeric: true, disablePadding: false, label: 'CP' },
        { id: 'provincia', numeric: true, disablePadding: false, label: 'Provincia' },
        { id: 'población', numeric: true, disablePadding: false, label: 'Población' },
        { id: 'modificar', numeric: true, disablePadding: false, label: '' }
    ];

    const headerColab = [
        { id: 'nombre', numeric: false, disablePadding: true, label: 'Nombre' },
        { id: 'modificar', numeric: true, disablePadding: false, label: '' }
    ];

    if (loading) {
        return <div>Cargando...</div>;
    }

    return (
        <>
            <CabeceraForm>
                <Titulo texto="EMPRESAS" tituloTabla="true" />
            </CabeceraForm>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tabActual} onChange={(e, v) => setTabActual(v)} 
                    sx={{
                        '& .MuiTab-root': {
                            fontWeight: 'bold',
                            textTransform: 'none',
                            fontSize: '1rem'
                        },
                        '& .Mui-selected': {
                            color: '#336385'
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#336385'
                        }
                    }}>
                    <Tab label="Negocios" icon={<Building  size={18} />} iconPosition="start" />
                    <Tab label="Empresas" icon={<Building2 size={18} />} iconPosition="start" />
                    <Tab label="Colaboradoras" icon={<Handshake size={18} />} iconPosition="start" />
                </Tabs>
            </Box>

            {tabActual === 0 && (
                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    departamentos={departamentos}
                    personas={personas}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarSeleccion={eliminarSeleccion}
                    setEliminarSeleccion={setEliminarSeleccion}
                />
            )}

            {tabActual === 1 && (
                <EnhancedTable
                    data={dataEmpresa.rows}
                    header={headerEmpresas}
                    meta={dataEmpresa.meta}
                    departamentos={[]}
                    personas={[]}
                    selected={selectedEmpresa}
                    setSelected={setSelectedEmpresa}
                    eliminarSeleccion={eliminarSeleccionEmpresa}
                    setEliminarSeleccion={setEliminarSeleccionEmpresa}
                    tipoEmpresa={true}
                />
            )}

            {tabActual === 2 && (
                <EnhancedTable
                    data={dataColab.rows}
                    header={headerColab}
                    meta={dataColab.meta}
                    departamentos={[]}
                    personas={[]}
                    selected={selectedColab}
                    setSelected={setSelectedColab}
                    eliminarSeleccion={eliminarSeleccionColab}
                    setEliminarSeleccion={setEliminarSeleccionColab}
                    tipoColaboradora={true}
                />
            )}
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 0 0% 1% 0%;
`

export default GestionPersonasEmpresas;
